//
import { ProductModel } from '@/models'
import { generateDeleteItemFunction } from '../DataTableService'

//
import create from './create'
import fetchAll from './fetchAll'
import fetchById from './fetchById'
import dtFetchData from './fetchDataTable'
import fetchSuggestInternalCode from './fetchSuggestInternalCode'
import remove from './remove'
import update from './update'
import fetchByIdPromo from './fetchByIdPromo'
//
const dtDeleteItem = generateDeleteItemFunction( ProductModel )

//
export default {
    create,
    dtFetchData,
    dtDeleteItem,
    fetchAll,
    fetchById,
    fetchSuggestInternalCode,
    remove,
    update,
    fetchByIdPromo,
}
